import emotionStyled from '@emotion/styled';
import { CSSProperties, ComponentProps, ComponentType, ElementType } from 'react';
import type { CommonTheme } from './createMuiTheme';

export const styled = <TComponent extends ElementType>(
  Component: TComponent,
  options?: Parameters<typeof emotionStyled>[1],
) => {
  const creator = emotionStyled(Component as any, options);
  const result = (
    stylesDef: CSSProperties | ((theme: CommonTheme, props?: any) => CSSProperties),
  ) =>
    typeof stylesDef === 'function'
      ? creator(({ theme, ...props }) => stylesDef(theme, props) as any)
      : creator(stylesDef as any);
  return result;
};

export type CustomStyled<TCustomTheme> = <TComponent extends ElementType>(
  Component: TComponent,
  options?: Parameters<typeof emotionStyled>[1],
) => <TProps = {}>(
  a: CSSProperties | ((theme: TCustomTheme, p: TProps) => CSSProperties),
) => ComponentType<ComponentProps<TComponent> & TProps>;

// we should never use this export directly(use on a per theme basis)
export default styled as never;
